function labelForRatingsAndNoLevelSelected(ratings: string[]): string {
  if (ratings.length > 1) {
    return `Level ${ratings.join(', ')} or No Level`
  }
  return `Level ${ratings} or No Level`
}

function labelForRatings(ratings: string[]): string {
  if (ratings.length > 1) {
    return `Level ${ratings.slice(0, -1).join(', ')} or ${ratings.slice(-1)}`
  }
  return `Level ${ratings[0]}`
}

function thereAreRatingsSelected(ratings: string[]): boolean {
  return ratings.length > 0
}

function noLevelSelected(selectedNetworkRatings: string[]): boolean {
  return selectedNetworkRatings.some(x => x === '-1')
}

export function label(input: string[], defaultLabel?: string): string {
  const selectedNetworkRatings = input.sort()
  const ratings = selectedNetworkRatings.filter(x => x !== '-1')
  const noLevel = noLevelSelected(selectedNetworkRatings)
  const thereAreRatings = thereAreRatingsSelected(ratings)

  if (thereAreRatings && noLevel) {
    return labelForRatingsAndNoLevelSelected(ratings)
  } else if (thereAreRatings) {
    return labelForRatings(ratings)
  } else if (noLevel) {
    return 'No Level'
  }
  return defaultLabel || 'Program Rating'
}
